<template>
  <div>
    <h4
      class="font-weight-bolder text-dark mb-4 d-flex align-items-center justify-content-between"
    >
      Certificates
      <b-button
        size="sm"
        variant="outline-info"
        class="px-2 ml-3"
        @click="showCertificateFormModal(null)"
        :disabled="profile.certifications.length >= 25"
        ><i class="fas fa-plus-circle px-0"></i
      ></b-button>
    </h4>

    <div class="wizard-timeline" v-if="profile.certifications.length">
      <div
        class="wizard-timeline__item"
        v-for="certification in profile.certifications"
        :key="certification.id"
      >
        <div class="card py-4 px-5 shadow-xs flex-grow-1">
          <div class="d-flex justify-content-between">
            <div>
              <div
                class="grey--text mb-1"
                v-if="certification.start_month !== null"
              >
                ({{ getMonthName(certification.start_month) }}
                {{ certification.start_year }} -
                <span v-if="certification.not_expire == 1">Doesn't Expire</span>
                <span v-if="certification.not_expire == 0"
                  >{{ getMonthName(certification.end_month) }}
                  {{ certification.end_year }}</span
                >
                )
              </div>
              <h4 class="mb-2">
                {{ certification.organization }}
              </h4>
              <p class="mb-0 grey--text text--darken-1">
                {{ certification.name }}
              </p>
            </div>
            <div class="ml-4 d-flex align-items-center">
              <b-dropdown
                variant="outline-info"
                right
                no-caret
                toggle-class="p-2 ml-3"
                menu-class="p-0"
              >
                <template #button-content>
                  <i class="flaticon-more px-0"></i>
                </template>
                <b-dropdown-item
                  href="#"
                  @click.prevent="showCertificateFormModal(certification)"
                  >Edit</b-dropdown-item
                >
                <b-dropdown-item
                  href="#"
                  @click.prevent="confirmDeleteProject(certification.id)"
                  >Delete</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
          <p class="mb-0" v-if="certification.identifier">
            <span class="text-dark">Credential I.D :</span>
            {{ certification.identifier }}
          </p>
          <a
            v-if="certification.url"
            :href="getUrl(certification.url)"
            class="text-info text-decoration-underline text-nowrap"
            target="_blank"
            >View Certificate</a
          >
        </div>
      </div>
    </div>

    <h6 class="text-muted mb-0" v-else>No Data</h6>

    <CertificationFormModal :activeCertification="activeCertification">
      <template #default="{ on }">
        <span ref="certification-modal" v-on="on"></span>
      </template>
    </CertificationFormModal>
  </div>
</template>

<script>
import CertificationFormModal from "@/components/talent-profile/modals/CertificationFormModal.vue";
import Swal from "sweetalert2";
import MONTHS from "@/constants/months";
import { getUrl } from "@/helpers";
export default {
  name: "Experience",
  components: { CertificationFormModal },
  props: {
    profile: {
      required: true,
    },
  },
  data() {
    return {
      activeCertification: null,
    };
  },
  methods: {
    getUrl,
    getMonthName(monthId) {
      return MONTHS.find((month) => month.id === monthId)?.name;
    },
    showCertificateFormModal(certification) {
      if (certification) {
        this.activeCertification = JSON.parse(JSON.stringify(certification));
      } else {
        this.activeCertification = null;
      }
      this.$refs["certification-modal"].click();
    },
    confirmDeleteProject(certificationId) {
      Swal.fire({
        title: "Are you sure",
        text: "You want to delete it?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#6f56c5",
        cancelButtonColor: "#E4E6EF",
        customClass: {
          cancelButton: "text-dark",
          icon: "text-danger border-danger",
        },
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          let payload = {
            certificationId,
            talent_id: this.$route.params.id,
          };
          this.$store.dispatch(
            "talentProfile/deleteTalentCertification",
            payload
          );
        }
      });
    },
  },
};
</script>
